import { createSelector } from 'reselect'
import getEnvironment, { Environment } from '@bt-react/libs/getEnvironment'
import selectSlideDeck from '../selectSlideDeck'

const bridgeName = state => state.config.bridgeName

const { env } = getEnvironment()
const isLocalHost = env === Environment.localhost


const rewriteIfLocal = url => {

  let newUrl
  if( !isLocalHost ) return url

  try {
    newUrl = new URL( url )
  }
  catch{
    return url
  }

  newUrl.hostname = 'localhost'
  newUrl.port = '4200'
  newUrl.protocol = 'http'
  return newUrl.href
}

const selectSlideDeckURL = createSelector([
    selectSlideDeck,
    bridgeName
  ],
  ( slideDeck, bridge ): String => {

    const fileLocation = bridge ? slideDeck.s3Location : slideDeck.brightTalkLocation
    return rewriteIfLocal( fileLocation )
  }
)

export default selectSlideDeckURL
